import {
  ROUTE_FORGET_PASSWORD,
  ROUTE_LOGIN,
  ROUTE_RESET_PASSWORD,
} from "./auth.routes";
import LoginPage from "../../modules/auth/login.page";
import {
  ROUTE_DASHBOARD,
  ROUTE_MANAGE_DEPARTMENT,
  ROUTE_MANAGE_STAFF,
  ROUTE_STAFF_PROFILE,
  ROUTE_MANAGE_PROJECT,
  ROUTE_MILESTONES,
  ROUTE_MANAGE_BILLING_CYCLE,
  ROUTE_MANAGE_VENDOR,
  ROUTE_BILLING_SUMMARY,
  ROUTE_ALLOCATION_REPORT,
  ROUTE_MANAGE_ACCOUNT,
  ROUTE_MANAGE_SUB_DEPARTMENT,
  ROUTE_MANAGE_FOREX,
  ROUTE_CANDIDATE_SCREENING,
  ROUTE_RESUME_MASTER,
  ROUTE_SCREENING_RESULTS,
  // ROUTE_SCREENING_RULES,
  ROUTE_SCREENING_AI_CONFIG,
  ROUTE_MANAGE_USERS,
  ROUTE_MANAGE_ROLES,
  ROUTE_MANAGE_DOCUMENT_TYPE,
  ROUTE_MANAGE_DOCUMENT_SUB_TYPE,
} from "./private.routes";
import ManageStaffPage from "../../modules/staff/manage-staff.page";
import StaffProfilePage from "../../modules/staff/staff-profile.page";
import ManageDepartmentPage from "../../modules/department/manage-department.page";
import ManageProjectPage from "../../modules/project/manage-project.page";
import ManageMilestonesPage from "../../modules/project/manage-milestones.page";
import ManageBillingCyclePage from "../../modules/project/manage-billing-cycle.page";
import ManageVendorPage from "../../modules/vendor/manage-vendor.page";
import BillingCycleSummary from "../../modules/project/billing-summary.page";
import AllocationReportPage from "../../modules/project/allocation-report.page";
import ManageAccountsPage from "../../modules/accounts/manage-accounts.page";
import ManageSubDepartmentPage from "../../modules/department/manage-sub-department.page";
import StaffAssignmentSummaryComponent from "../../modules/project/components/staff-assignment-summary.component";
import ManageForexPage from "../../modules/forex/manage-forex.page";
import ManageJobDescriptionPage from "../../modules/candidate-screening/manage-job-description.page";
import ResumeMasterPage from "../../modules/candidate-screening/resume-master.page";
import ScreeningResultsPage from "../../modules/candidate-screening/screening-results.page";
// import ManageScreeningRulesPage from "../../modules/candidate-screening/manage-screening-rules.page";
import AiConfigPage from "../../modules/candidate-screening/ai-config.page";
import ManageUsersPage from "../../modules/users/manage-users.page";
import ManageRolesPage from "../../modules/roles/manage-roles.page";
import ManageDocumentTypePage from "../../modules/document-type/manage-document-type.page";
import ManageDocumentSubTypePage from "../../modules/document-sub-type/manage-document-sub-type.page";
import DashboardPage from "../../modules/dashboard/dashboard.page";
import { allPermissions } from "../constants/constants";

export const ROUTES_OPEN: any[] = [
  {
    name: "Login",
    route: ROUTE_LOGIN,
    component: <LoginPage />,
  },
  // {
  //   name: "Reset Pasword",
  //   route: ROUTE_RESET_PASSWORD,
  //   component: <ResetPasswordPage />,
  // },
  // {
  //   name: "Forget Password",
  //   route: ROUTE_FORGET_PASSWORD,
  //   component: <ForgotPasswordPage />,
  // },
];

export const ROUTES_PROTECTED: any[] = [
  {
    name: "Dashboard",
    module: "DASHBOARD",
    route: ROUTE_DASHBOARD,
    permission: [allPermissions.VIEW_DASHBOARD],
    component: <DashboardPage />,
  },
  {
    name: "Staff",
    module: "STAFF",
    route: ROUTE_MANAGE_STAFF,
    permission: [allPermissions.VIEW_STAFF],
    component: <ManageStaffPage />,
  },
  {
    name: "Staff Profile",
    module: "STAFF",
    route: ROUTE_STAFF_PROFILE,
    permission: [allPermissions.VIEW_STAFF],
    component: <StaffProfilePage />,
  },
  {
    name: "Department",
    module: "DEPARTMENT",
    route: ROUTE_MANAGE_DEPARTMENT,
    permission: [allPermissions.VIEW_DEPARTMENT],
    component: <ManageDepartmentPage />,
  },
  {
    name: "Sub Department",
    module: "SUB_DEPARTMENT",
    route: ROUTE_MANAGE_SUB_DEPARTMENT,
    permission: [allPermissions.VIEW_SUBDEPARTMENT],
    component: <ManageSubDepartmentPage />,
  },
  {
    name: "Project",
    module: "PROJECT",
    route: ROUTE_MANAGE_PROJECT,
    permission: [allPermissions.VIEW_PROJECT],
    component: <ManageProjectPage />,
  },
  {
    name: "Milestones",
    module: "MILESTONES",
    route: ROUTE_MILESTONES,
    permission: [allPermissions.VIEW_PROJECT],
    component: <ManageMilestonesPage />,
  },
  {
    name: "Billing Cycle",
    module: "BILLING_CYCLE",
    route: ROUTE_MANAGE_BILLING_CYCLE,
    permission: [allPermissions.VIEW_BILLING_SUMMARY],
    component: <ManageBillingCyclePage />,
  },
  {
    name: "Billing Summary",
    module: "BILLING_CYCLE",
    route: ROUTE_BILLING_SUMMARY,
    permission: [allPermissions.VIEW_BILLING_SUMMARY],
    // component: <BillingCycleSummary />,
    component: <StaffAssignmentSummaryComponent/>
  },
  {
    name: "Allocation Report",
    module: "PROJECT",
    route: ROUTE_ALLOCATION_REPORT,
    component: <AllocationReportPage />,
  },
  {
    name: "Vendor",
    module: "VENDOR",
    route: ROUTE_MANAGE_VENDOR,
    permission: [allPermissions.VIEW_VENDOR],
    component: <ManageVendorPage />,
  },
  {
    name: "Accounts",
    module: "ACCOUNTS",
    route: ROUTE_MANAGE_ACCOUNT,
    permission: [allPermissions.VIEW_ACCOUNT],
    component: <ManageAccountsPage />,
  },
  {
    name: "Forex",
    module: "FOREX",
    route: ROUTE_MANAGE_FOREX,
    permission: [allPermissions.VIEW_FOREX],
    component: <ManageForexPage />,
  },
  {
    name: "Candidate Screening",
    module: "CANDIDATE_SCREENING",
    route: ROUTE_CANDIDATE_SCREENING,
    permission: [allPermissions.VIEW_JD_MASTER],
    component: <ManageJobDescriptionPage />,
  },
  {
    name: "Resume Master",
    module: "CANDIDATE_SCREENING",
    route: ROUTE_RESUME_MASTER,
    permission: [allPermissions.VIEW_RESUME_MASTER],
    component: <ResumeMasterPage />,
  },
  {
    name: "Screening Results",
    module: "CANDIDATE_SCREENING",
    route: `${ROUTE_SCREENING_RESULTS}/:jobDescriptionId`,
    permission: [allPermissions.JD_MASTER_RANK],
    component: <ScreeningResultsPage />,
  },
  // {
  //   name: "Screening Rules",
  //   module: "CANDIDATE_SCREENING",
  //   route: ROUTE_SCREENING_RULES,
  //   component: <ManageScreeningRulesPage />,
  // },
  {
    name: "AI Configuration",
    module: "CANDIDATE_SCREENING",
    route: ROUTE_SCREENING_AI_CONFIG,
    permission: [allPermissions.AICONFIG_VIEW],
    component: <AiConfigPage />,
  },
  {
    name: "Users",
    module: "USERS",
    route: ROUTE_MANAGE_USERS,
    permission: [allPermissions.VIEW_USER],
    component: <ManageUsersPage />,
  },
  {
    name: "Roles",
    module: "ROLES",
    route: ROUTE_MANAGE_ROLES,
    permission: [allPermissions.VIEW_ROLE],
    component: <ManageRolesPage />,
  },
  {
    name: "Document Type",
    module: "DOCUMENT_MANAGEMENT",
    route: ROUTE_MANAGE_DOCUMENT_TYPE,
    permission: [allPermissions.VIEW_DOCUMENT_TYPE],
    component: <ManageDocumentTypePage />,
  },
  {
    name: "Document Sub Type",
    module: "DOCUMENT_MANAGEMENT",
    route: ROUTE_MANAGE_DOCUMENT_SUB_TYPE,
    permission: [allPermissions.VIEW_DOCUMENT_SUB_TYPE],
    component: <ManageDocumentSubTypePage />,
  },
];
